import { jsx as _jsx } from "react/jsx-runtime";
// =============================================================================
//  Copyright : 2025 semantics GmbH
//  Date      : $Date: 2025-11-27 00:57:15 +0100 (Thu, 27 Nov 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 158690 $
//  Purpose   : generic menu operations for metadata nodes
// =============================================================================
// ---Third-party imports
import React from 'react';
// ---Framework imports
import { mapItems } from 'ldash';
import { Actions, Sel } from 'uix/registries';
import log from 'uix/logging';
import { JobMenuButton } from 'uix/job/components';
export const MetadataUpdateItem = {
    nodeMenuItem: ({ dconfig, node, i18n })=>{
        return /*#__PURE__*/ _jsx(JobMenuButton, {
            label: "Update",
            name: "UpdateMetadataJob",
            params: {
                ids: [
                    node.otid
                ]
            }
        });
    },
    acl: 'g:admin',
    enabled: ({ dconfig, node })=>node.datatype == 1
};
